export const translationConfig = {
  uiFiles: ['core', 'table_name', 'highflyer','promo'],
  helpFiles: ['commoncrash', 'highflyer'],
  excludedLanguages: [],
};
